import { translate } from '@thoughtspot/i18n';
import { OptionsGroup } from '@thoughtspot/radiant-react/widgets/select/base-select';
import _ from 'lodash';
import { Month, Quarter } from '/@services/generated/graphql-types';
import { DateFilterProto } from '../../date-filter';
import {
    getFixedDateFilterOperator,
    operatorToDateTypeAndFilterType,
} from './fixed-date-filter.util';

export const MIN_YEAR = 1000;
export const MAX_YEAR = 9999;
export const MAX_YEAR_LENGTH = 4;
export const YEAR_PLACEHOLDER = 'YYYY';
export const DEFAULT_MONTH_VALUE = _.toLower(Month.January);
export const DEFAULT_QUARTER_VALUE = _.toLower(Quarter.Q1);
export const getMonthDropdownOptions = (): OptionsGroup[] => [
    {
        options: [
            {
                id: Month.January,
                label: translate('monthOfYear.January'),
                data: _.toLower(Month.January),
            },
            {
                id: Month.February,
                label: translate('monthOfYear.February'),
                data: _.toLower(Month.February),
            },
            {
                id: Month.March,
                label: translate('monthOfYear.March'),
                data: _.toLower(Month.March),
            },
            {
                id: Month.April,
                label: translate('monthOfYear.April'),
                data: _.toLower(Month.April),
            },
            {
                id: Month.May,
                label: translate('monthOfYear.May'),
                data: _.toLower(Month.May),
            },
            {
                id: Month.June,
                label: translate('monthOfYear.June'),
                data: _.toLower(Month.June),
            },
            {
                id: Month.July,
                label: translate('monthOfYear.July'),
                data: _.toLower(Month.July),
            },
            {
                id: Month.August,
                label: translate('monthOfYear.August'),
                data: _.toLower(Month.August),
            },
            {
                id: Month.September,
                label: translate('monthOfYear.September'),
                data: _.toLower(Month.September),
            },
            {
                id: Month.October,
                label: translate('monthOfYear.October'),
                data: _.toLower(Month.October),
            },
            {
                id: Month.November,
                label: translate('monthOfYear.November'),
                data: _.toLower(Month.November),
            },
            {
                id: Month.December,
                label: translate('monthOfYear.December'),
                data: _.toLower(Month.December),
            },
        ],
    },
];

export const getQuarterDropdownOptions = (): OptionsGroup[] => [
    {
        options: [
            {
                id: Quarter.Q1,
                label: translate('QUARTER_OF_YEAR', { 1: 1 }),
                data: _.toLower(Quarter.Q1),
            },
            {
                id: Quarter.Q2,
                label: translate('QUARTER_OF_YEAR', { 1: 2 }),
                data: _.toLower(Quarter.Q2),
            },
            {
                id: Quarter.Q3,
                label: translate('QUARTER_OF_YEAR', { 1: 3 }),
                data: _.toLower(Quarter.Q3),
            },
            {
                id: Quarter.Q4,
                label: translate('QUARTER_OF_YEAR', { 1: 4 }),
                data: _.toLower(Quarter.Q4),
            },
        ],
    },
];

// To change the selected filter on tab change with the already selected values
// or if nothing is selected then with default values
export const updateDefaultFixedFilterValues = (
    selectedFilter: DateFilterProto,
) => {
    const { filterType, dateFilterType, dateValue, isNegate } = selectedFilter;
    const selectedMonth = dateValue?.monthName || DEFAULT_MONTH_VALUE;
    const selectedQuarter = dateValue?.quarterName || DEFAULT_QUARTER_VALUE;
    const filterOperator = getFixedDateFilterOperator(
        filterType,
        dateFilterType,
        isNegate,
    );
    return {
        dateValue: {
            ...dateValue,
            monthName: selectedMonth,
            quarterName: selectedQuarter,
        },
        ...operatorToDateTypeAndFilterType[filterOperator],
    };
};
